// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/BezierSans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/BezierSans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/BezierSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/BezierSansBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/fonts/BezierSansRegular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Bezier Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
         url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: normal;
    font-style: normal;

    font-family: 'Bezier Sans Bold';
    src:
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: normal;

    font-family: 'Bezier Sans Regular';
    src: 
         url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  body {
    font-family: 'Bezier Sans', sans-serif;
  }
  

.home {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 8%;
    /*padding-left: 100px;
    padding-right: 100px;
    /*box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3); /* Тень снизу */
    

    /*height: calc(100vh - 80px); /* Высота экрана минус высота шапки */
}

.text-image-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    padding-bottom: 20px;
    
    position: relative; /*margin: 20px 0; */
    background-color: #ffffff; /* Белый фон для контейнера */

    /*!!width: 2949.6px; /* Установлена фиксированная ширина */
    /*height: 560.4px; /* Установлена фиксированная высота */
    /* border-radius: 8px; /* Скругление углов */
}

.text-image-container::after {
    content: '';
    position: absolute;
    /*!!left: 0;
    right: 0;
    bottom: 0;
    height: 20px; /* Высота подсветки */
    background: linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8)); /* Градиент для подсветки */
    pointer-events: none; /* Предотвращаем взаимодействие с псевдоэлементом */
}
.text-main{
    font-family: 'Bezier Sans Bold';
}

.text-mini{
    font-family: 'Bezier Sans', sans-serif;
}

.text {
    flex: 1 1;
    padding: 10px;
    padding-left: 40px;
    font-size: 18px;
    line-height: 1.6;
    font-family: 'Bezier Sans', sans-serif;
    

    /* font-weight: 700;
    height: 281px; */
    text-align: center;

    /* Центрирование текста по вертикали, если необходимо */
    display: flex;
    flex-direction: column;
    justify-content: center;
}


.image {
    flex: 1 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: auto;
}

.image img {
    max-width: 600px;
    width: 90%;
    height: auto;
    border-radius: 8px; /* Keeps the corners rounded */
}


.text-container {
    display: flex;
    /*!!justify-content: space-around;*/
    margin-top: 20px; /* Отступ сверху */
}

.text-line {
    text-align: center;
}

/* Медиа-запрос для мобильных устройств */
@media screen and (max-width: 768px) {

    .home{
        padding-top: 100px;
    }

    .text-image-container {
        width: 100%;
        
        flex-direction: column; /* Столбцовое расположение кнопок на мобильных устройствах 
        max-width: 300px;
        */
        align-items: center; /* Центрируем кнопки по центру */
    }

    .image {
        width: 80%; /* Уменьшаем ширину изображения */
        height: auto; /* Автоматически устанавливаем высоту */
        margin-top: 20px; /* Добавляем отступ сверху */
    }
    
    .image img {
        width: 100%; /* Изображение занимает всю ширину контейнера */
        height: auto; /* Высота сохраняет пропорции изображения */
        border-radius: 8px; /* Сохраняем скругленные углы */
    }

    .text {
        padding: 10px; /* Уменьшаем отступы текста */
        font-size: 16px; /* Уменьшаем размер шрифта */
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Home.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B;;mEAEgE;IAChE,mBAAmB;IACnB,kBAAkB;;IAElB,+BAA+B;IAC/B;mEACoE;IACpE,mBAAmB;IACnB,kBAAkB;;IAElB,kCAAkC;IAClC;mEACuE;IACvE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,sCAAsC;EACxC;;;AAGF;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf;;+DAE2D;;;IAG3D,mEAAmE;AACvE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,oBAAoB;;IAEpB,kBAAkB,EAAE,mBAAmB;IACvC,yBAAyB,EAAE,6BAA6B;;IAExD,0DAA0D;IAC1D,wDAAwD;IACxD,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB;;;uCAGmC;IACnC,qFAAqF,EAAE,2BAA2B;IAClH,oBAAoB,EAAE,mDAAmD;AAC7E;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;;;IAGtC;oBACgB;IAChB,kBAAkB;;IAElB,uDAAuD;IACvD,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;;AAGA;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,kBAAkB,EAAE,8BAA8B;AACtD;;;AAGA;IACI,aAAa;IACb,mCAAmC;IACnC,gBAAgB,EAAE,kBAAkB;AACxC;;AAEA;IACI,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;;IAEI;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;;QAEX,sBAAsB,EAAE;;SAEvB;QACD,mBAAmB,EAAE,gCAAgC;IACzD;;IAEA;QACI,UAAU,EAAE,iCAAiC;QAC7C,YAAY,EAAE,uCAAuC;QACrD,gBAAgB,EAAE,4BAA4B;IAClD;;IAEA;QACI,WAAW,EAAE,+CAA+C;QAC5D,YAAY,EAAE,2CAA2C;QACzD,kBAAkB,EAAE,+BAA+B;IACvD;;IAEA;QACI,aAAa,EAAE,6BAA6B;QAC5C,eAAe,EAAE,4BAA4B;IACjD;AACJ","sourcesContent":["@font-face {\r\n    font-family: 'Bezier Sans';\r\n    src: url('../../public/fonts/BezierSans.woff2') format('woff2'),\r\n         url('../../public/fonts/BezierSans.woff') format('woff'),\r\n         url('../../public/fonts/BezierSans.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n\r\n    font-family: 'Bezier Sans Bold';\r\n    src:\r\n         url('../../public/fonts/BezierSansBold.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n\r\n    font-family: 'Bezier Sans Regular';\r\n    src: \r\n         url('../../public/fonts/BezierSansRegular.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n  }\r\n  body {\r\n    font-family: 'Bezier Sans', sans-serif;\r\n  }\r\n  \r\n\r\n.home {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-top: 8%;\r\n    /*padding-left: 100px;\r\n    padding-right: 100px;\r\n    /*box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3); /* Тень снизу */\r\n    \r\n\r\n    /*height: calc(100vh - 80px); /* Высота экрана минус высота шапки */\r\n}\r\n\r\n.text-image-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    \r\n    padding-bottom: 20px;\r\n    \r\n    position: relative; /*margin: 20px 0; */\r\n    background-color: #ffffff; /* Белый фон для контейнера */\r\n\r\n    /*!!width: 2949.6px; /* Установлена фиксированная ширина */\r\n    /*height: 560.4px; /* Установлена фиксированная высота */\r\n    /* border-radius: 8px; /* Скругление углов */\r\n}\r\n\r\n.text-image-container::after {\r\n    content: '';\r\n    position: absolute;\r\n    /*!!left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    height: 20px; /* Высота подсветки */\r\n    background: linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8)); /* Градиент для подсветки */\r\n    pointer-events: none; /* Предотвращаем взаимодействие с псевдоэлементом */\r\n}\r\n.text-main{\r\n    font-family: 'Bezier Sans Bold';\r\n}\r\n\r\n.text-mini{\r\n    font-family: 'Bezier Sans', sans-serif;\r\n}\r\n\r\n.text {\r\n    flex: 1;\r\n    padding: 10px;\r\n    padding-left: 40px;\r\n    font-size: 18px;\r\n    line-height: 1.6;\r\n    font-family: 'Bezier Sans', sans-serif;\r\n    \r\n\r\n    /* font-weight: 700;\r\n    height: 281px; */\r\n    text-align: center;\r\n\r\n    /* Центрирование текста по вертикали, если необходимо */\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n\r\n.image {\r\n    flex: 1;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.image img {\r\n    max-width: 600px;\r\n    width: 90%;\r\n    height: auto;\r\n    border-radius: 8px; /* Keeps the corners rounded */\r\n}\r\n\r\n\r\n.text-container {\r\n    display: flex;\r\n    /*!!justify-content: space-around;*/\r\n    margin-top: 20px; /* Отступ сверху */\r\n}\r\n\r\n.text-line {\r\n    text-align: center;\r\n}\r\n\r\n/* Медиа-запрос для мобильных устройств */\r\n@media screen and (max-width: 768px) {\r\n\r\n    .home{\r\n        padding-top: 100px;\r\n    }\r\n\r\n    .text-image-container {\r\n        width: 100%;\r\n        \r\n        flex-direction: column; /* Столбцовое расположение кнопок на мобильных устройствах \r\n        max-width: 300px;\r\n        */\r\n        align-items: center; /* Центрируем кнопки по центру */\r\n    }\r\n\r\n    .image {\r\n        width: 80%; /* Уменьшаем ширину изображения */\r\n        height: auto; /* Автоматически устанавливаем высоту */\r\n        margin-top: 20px; /* Добавляем отступ сверху */\r\n    }\r\n    \r\n    .image img {\r\n        width: 100%; /* Изображение занимает всю ширину контейнера */\r\n        height: auto; /* Высота сохраняет пропорции изображения */\r\n        border-radius: 8px; /* Сохраняем скругленные углы */\r\n    }\r\n\r\n    .text {\r\n        padding: 10px; /* Уменьшаем отступы текста */\r\n        font-size: 16px; /* Уменьшаем размер шрифта */\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
